import i18nMain from './vi/i18nMain';
// import i18nValidate from './vi/i18nValidate';
import i18nCommon from './vi/i18nCommon';
import i18nEnum from './vi/i18nEnum';
import i18nComponent from './vi/i18nComponent';
import i18nColumn from './vi/i18nColumn';
import i18nPages from './vi/i18nPages';
import i18nColumnTemplate from './vi/i18nColumnTemplate';
import i18nBaseForm from './vi/i18nBaseForm';
import i18nEmployee from './vi/i18nEmployee';


export default {
    vi: {
        i18nMain,
        // i18nValidate,
        i18nCommon,
        i18nComponent,
        i18nEnum,
        i18nColumn,
        i18nPages,
        i18nBaseForm,
        i18nColumnTemplate,
        i18nEmployee,
    },
};